export default __webpack_public_path__ + "10954e7fc056dca77518db85a3c0243e.png";